import type { IconData } from '@stacksjs/iconify-core'

export const loadingHorizontal2Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 17.5a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13M13.5 24c0-5.799 4.701-10.5 10.5-10.5S34.5 18.201 34.5 24S29.799 34.5 24 34.5S13.5 29.799 13.5 24m-7-5.5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11m35 0a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default loadingHorizontal2Remix
